module.exports = __webpack_public_path__ + "img/9c796ae3bb2c56103deca16104fc6580.svg";